import { GeneralSettings } from '../components/settings/GeneralSettings'

export function UserPreferences() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Preferences</h1>
        <p className="text-gray-600">Customize your application preferences and display settings</p>
      </div>

      <GeneralSettings />
    </div>
  )
}
